
let document_width = document.documentElement.clientWidth


// 注意这部分代码后面要清理
window.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll(".custom_collection_tab_title").forEach((titleEl) => {
    titleEl.addEventListener("click", function () {
      if (this.classList.contains("active")) return

      const siblings = Array.from(this.parentElement.querySelectorAll(".custom_collection_tab_title"))
      const index = siblings.indexOf(this)
      const classId = this.dataset.initid
      const pcNum = this.dataset.num || 4
      const link = this.dataset.link

      siblings.forEach((sib) => sib.classList.remove("active"))
      this.classList.add("active")

      if (link) {
        const linkEl = this.closest(".container")?.querySelector(".section__header .custom_collection_link")
        if (linkEl) linkEl.setAttribute("href", link)
      }

      const contentList = this.closest(".custom_collection_tab_container")?.querySelector(".custom_collection_tab_content_list")
      const contents = contentList ? Array.from(contentList.querySelectorAll(".custom_collection_tab_content")) : []
      contents.forEach((c) => (c.style.display = "none"))
      if (contents[index]) {
        contents[index].style.display = "block"
        initializeSwiper(classId, pcNum)
      }
    })
  })

  // 
  document.querySelectorAll(".custom-halloween-card-view-more").forEach((btn) => {
    btn.addEventListener("click", function () {
      const container = this.closest(".container")
      if (document_width > 750) {
        container.querySelectorAll(".custom-halloween-card-hidden-pc").forEach((el) => {
          el.classList.remove("custom-halloween-card-hidden-pc")
        })
      } else {
        container.querySelectorAll(".custom-halloween-card-hidden-m").forEach((el) => {
          el.classList.remove("custom-halloween-card-hidden-m")
        })
      }
      this.style.display = "none"
    })
  })
})





function initializeSwiper (class_name, pc_num) {

  new Swiper(`.custom_collection_tab_swiper_${class_name}`, {
    slidesPerView: "auto",
    spaceBetween: 10,
    freeMode: true,
    breakpoints: {
      750: {
        slidesPerView: pc_num,
        spaceBetween: 20,
        freeMode: false
      }
    },
    navigation: {
      nextEl: `.swiper-button-next_${class_name}`,
      prevEl: `.swiper-button-prev_${class_name}`,
    }
  })
}
